module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-three3.5ca00a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-three3.png
// module id = Qx2R
// module chunks = 0